// Module
var code = "<div class=\"ToolBarPreview\"> <label data-bind=\"attr: { title: Label }\"> <i class=\"fa fa-exchange\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;